import { TAGS } from "../constants";
import { ProductCategory, ProductCategoryCreate } from "../types";
import { api } from "./api";

export const productCategoriesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductCategories: builder.query<ProductCategory[], void>({
      query: () => ({
        method: "GET",
        url: `/api/product-categories`,
      }),
      providesTags: [TAGS.PRODUCT_CATEGORIES],
    }),
    createProductCategory: builder.mutation<
      ProductCategory,
      ProductCategoryCreate
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/product-categories`,
        body,
      }),
      invalidatesTags: [TAGS.PRODUCT_CATEGORIES],
    }),
  }),
});

export const {
  useGetProductCategoriesQuery,
  useCreateProductCategoryMutation,
} = productCategoriesApi;
